import { ReactElement, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getUserProfile } from 'helpers/userProfile';
import { handleUnitStatusByProfile } from 'helpers/unitStatus';
import { defaultFormValues } from 'pages/ClientPanel/Energy/EnergyContainer/EnergyConsumptionGoal/components/Form/constants';
import { EnergyConsumptionForm } from 'pages/ClientPanel/Energy/EnergyContainer/EnergyConsumptionGoal/components/Form';
import { Loader } from 'components';
import { EnergyConsumptionGoalContainer } from './styles';
import { getEnergyGoals, prepareAllUnitDataToForm } from 'helpers/energyGoals';
import { GetGoalsResponse, SetGoalsResponse } from '~/pages/ClientPanel/Energy/EnergyContainer/EnergyConsumptionGoal/types';

interface EnergyConsumptionGoalProps {
  clientId: number;
}

export function EnergyConsumptionGoal({
  clientId,
}: Readonly<EnergyConsumptionGoalProps>): ReactElement {
  const currentYear = new Date().getFullYear();

  const [loading, setLoading] = useState(false);
  const [profile] = useState(getUserProfile);
  const { unitId } = useParams<{ unitId: string }>();
  const [data, setData] = useState<GetGoalsResponse>([]);
  const [defaultValues, setDefaultValues] = useState({
    formValues: defaultFormValues,
    year: currentYear,
  });

  async function getGoals(): Promise<void> {
    setLoading(true);
    const response = await getEnergyGoals({
      CLIENT_ID: clientId,
      UNIT_IDS: [Number(unitId)],
      INCLUDE_UNIT_STATUS: handleUnitStatusByProfile(profile),
    });

    if (response.length > 0) {
      setData(response);
      setDefaultValues((prevData) => ({
        ...prevData,
        formValues: prepareAllUnitDataToForm(response),
      }));
    }

    setLoading(false);
  }

  function onSuccess(responses: SetGoalsResponse[]): void {
    const map = new Map(data.map((item) => [String(item.YEAR), item]));

    for (const response of responses) {
      map.set(String(response.YEAR), response);
    }

    const newData = Array.from(map.values());
    setData(newData);

    const newDefault = {
      year: currentYear,
      formValues: prepareAllUnitDataToForm(newData),
    };

    setDefaultValues(newDefault);
  }

  useEffect(() => {
    if (unitId && clientId) {
      getGoals();
    }
  }, []);

  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return (
    <EnergyConsumptionGoalContainer>
      <EnergyConsumptionForm
        loading={false}
        onSuccess={onSuccess}
        defaultValues={defaultValues}
        unitId={unitId}
      />
    </EnergyConsumptionGoalContainer>
  );
}
